import React, { useMemo } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Button } from "../ui/button";
import { Bell, Settings } from "lucide-react";
import { Separator } from "../ui/separator";
import { AlertsPreferences } from "./AlertsPreferences";
import { useNotifications } from "@/hooks/use-notifications";
import { AlertsNotificationsItem } from "./AlertsNotificationsItem";
import { AlertsButton } from "./AlertsButton";
import { useIsMobile } from "@/hooks/use-mobile";
import clsx from "clsx";
import { Link } from "react-router-dom";

const SHOW_MORE_COUNT = 5;

export const AlertsPopover: React.FC = () => {
  const [isPreferencesSeen, setIsPreferencesSeen] = React.useState(false);

  const notifications = useNotifications();

  const sliseNotifications = useMemo(() => {
    return notifications.slice(0, SHOW_MORE_COUNT);
  }, [notifications]);

  const isShowMore = useMemo(() => {
    return notifications.length > SHOW_MORE_COUNT;
  }, [notifications]);

  const moreCount = useMemo(() => {
    return notifications.length - SHOW_MORE_COUNT;
  }, [notifications]);

  const isMobile = useIsMobile();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <AlertsButton
          className={clsx("dark:text-white", {
            "text-white": !isMobile,
            "text-black": isMobile,
          })}
        />
      </PopoverTrigger>
      <PopoverContent className="p-0 max-h-[500px] overflow-y-auto">
        {!isPreferencesSeen ? (
          <>
            <div className="inline-flex w-full p-3 justify-between items-center">
              <h3 className="font-medium">Notifications</h3>
              <Button
                variant="ghost"
                size="icon"
                className="size-8"
                onClick={() => setIsPreferencesSeen(true)}
              >
                <Settings className="size-4" />
              </Button>
            </div>
            <Separator />
            <div className="grid gap-2">
              {!sliseNotifications.length && (
                <div className="flex flex-col items-center justify-center text-center py-8">
                  <Bell className="h-8 w-8 text-muted-foreground mb-2" />
                  <p className="text-sm text-muted-foreground">
                    No notifications
                  </p>
                </div>
              )}
              {sliseNotifications.map((notification, index) => (
                <div
                  key={notification.id}
                  className={clsx("px-4 py-2 border-b last:border-b-0", {})}
                >
                  <AlertsNotificationsItem
                    key={notification.id}
                    notification={notification}
                  />
                </div>
              ))}
            </div>
            {isShowMore && (
              <div className="px-4 py-2 text-center w-full border-t">
                <Link to="/notifications">
                  <Button variant={"outline"} className="w-full">
                    Show all ({moreCount})
                  </Button>
                </Link>
              </div>
            )}
          </>
        ) : (
          <AlertsPreferences onClose={() => setIsPreferencesSeen(false)} />
        )}
      </PopoverContent>
    </Popover>
  );
};
